import React, {useState} from 'react';
import './InsightMain.css';
import Linker from '../../linker/Linker'
import * as path from '../../../../route/PathConfig'
import PaginationAnything from '../../pagination/PaginationAnything';

const getSummary = (content) => {
  let summary = content.replaceAll(/(<([^>]+)>)/ig,"").replaceAll(/(\r|\n|&nbsp;)/ig," ");
  // let summary = content.replaceAll(/(<(/)?([a-zA-Z]*)(\\s[a-zA-Z]*=[^>]*)?(\\s)*(/)?>)/ig,"").replaceAll(/(\r|\n|&nbsp;)/ig,"");

  if(summary.length > 22) {
    summary = summary.substr(0, 22) + "...";
  }
  return summary;
}

const InsightMain = (props) => {
  const insightIndexSize=6;
  const pageLength = Math.ceil(props.insightContent.length/insightIndexSize);
  const insightPageWindowSize=5;

  const [activePage, setActivePage] = useState(1);
  let currentInsightIndex = (activePage-1) * insightIndexSize;

  const handleActivePage = (index) => {
    setActivePage(index);
  }

  return (
    <>
      <div className="InsightTitle">
        <span className="blue">인사이트</span>
      </div>
      <div className="Insight_box">
        <div className="Insight_table">
          <div className="table_row">
            {props.insightContent.filter((item, index) => (index >= currentInsightIndex) && (index < currentInsightIndex + insightIndexSize/2)).map((row, rowIndex)=>{
              return (
                <div className="Insight_post">
                  <Linker path={`${path.INSIGHTPAGE}/${row.noticeID}`}>
                    {/* {row.noticeID} */}
                    <div href="" className="insightPhoto"></div>
                  </Linker>
                  <Linker path={`${path.INSIGHTPAGE}/${row.noticeID}`}>
                    {/* {row.noticeID} */}
                    <a href="" className="insightTitle">{getSummary(row.title)}</a>
                  </Linker>
                </div>
              )
            })}
          </div>
          <div className="table_row">
            {props.insightContent.filter((item, index) => (index >= currentInsightIndex + insightIndexSize/2) && (index < currentInsightIndex + insightIndexSize)).map((row, rowIndex)=>{
              return (
                <div className="Insight_post">
                  <Linker path={`${path.INSIGHTPAGE}/${row.noticeID}`}>
                    {/* {row.noticeID} */}
                    <div className="insightPhoto"></div>
                  </Linker>
                  <Linker path={`${path.INSIGHTPAGE}/${row.noticeID}`}>
                    <a href="" className="insightTitle">{getSummary(row.title)}</a>
                  </Linker>
                </div>
              )
            })}
          </div>
        </div>
        <div style={{textAlign: 'center'}}>
          <PaginationAnything windowSize={insightPageWindowSize} handleActivePage={handleActivePage} pageLength={pageLength} activePage={activePage} />
        </div>
      </div>
    </>
  )
}

export default InsightMain;